module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('blockquote', [_c('p', {
    staticClass: "V2"
  }, [_c('span', {
    attrs: {
      "aria-label": "4",
      "id": "pg_4",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("I never needed a Man.")])])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I needed a Viking.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I needed someone who wasn’t afraid")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("of my strengths")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("or of my needs.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I chose wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("in the past.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I thought I had to find someone who")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("could put up with my hunger for life.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("But I was so damn wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I needed a Viking.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I needed someone who could admire")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("all the things about me")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("that tepid men were intimidated by.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0